<template>
    <div class="inplay-details-page-section">
        <div class="container-fluid">
            <div class="input-field-section trm-condations-sec rule_info_wrapper">
                <div class="row">
                    <div class="col-12">
                        <div class="rule-details-page" v-html="siteRuleData?.General"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Rules',
    data(){
        return{
            siteRuleData:null
        }
    },
    mounted(){
        this.getRules();
    },
    methods:{
        getRules(bonus = false) { 
            let ruleResp = this.$siteSettings?.data?.rules;
            this.siteRuleData = {}
            ruleResp.forEach(item => {
                this.siteRuleData[item.type] = item.content;
            })
        },
    }

}
</script>

<style></style>